import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideHttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideMessaging, getMessaging } from '@angular/fire/messaging'; // Corrected import
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { providePrimeNG } from 'primeng/config';
import { AuthInterceptor } from 'src/app/all-modules/auth.interceptor';
import Aura from '@primeng/themes/aura';
import customBlueColorPalette from './sharing/mypreset';
export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
     { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideRouter(routes),
    importProvidersFrom(BrowserAnimationsModule),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [HttpClient]
        }
      })
    ),
    providePrimeNG({
      theme: {
        preset: localStorage.getItem('theme')|| customBlueColorPalette,
        options: {
        }
      },
    }),
    importProvidersFrom(
      ToastrModule.forRoot({
        timeOut: 9000,
        positionClass: 'toast-center-center',
        preventDuplicates: true,
        closeButton: true, 
      })
    ),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideMessaging(() => getMessaging()),
  ]
};